<div class="d-flex align-items-center py-3 py-md-0">

    <div class="container containterWidth">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-body cardWidth">
              <h2 class="mt-2 mb-4">Register</h2>
              <form action="#!" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                  <div class="form-group row">
                    <div class="col-md-6"><label for="firstName"  class="dangerAstrick">First Name</label>
                      <input type="text" formControlName="firstName" name="firstName" id="firstName" class="form-control" placeholder="First Name"  [ngClass]="{ 'is-invalid': submitted && f?.firstName.errors }" >                       
                      <div *ngIf="submitted && f?.firstName.errors" class="invalid-feedback">
                        <div *ngIf="f?.firstName.errors.required">First Name is required</div>
                      </div></div>
                        
                        <div class="col-md-6">
                          <label for="lastName">Last Name</label>
                        <input type="text" formControlName="lastName" name="lastName" id="lastName" class="form-control" placeholder="Last Name"  [ngClass]="{ 'is-invalid': submitted && f?.lastName.errors }" >                       
                        <div *ngIf="submitted && f?.lastName.errors" class="invalid-feedback">
                          <div *ngIf="f?.lastName.errors.required">Last Name is required</div>
                        </div>
                        </div>

                    </div>
                    <div class="form-group row">
                      <div class="col-md-6"><label for="ssn"  class="dangerAstrick">Social Security Number</label>
                        <input type="text" formControlName="ssn" name="ssn" id="ssn" class="form-control" placeholder="ÅÅMMDDNNNN"  [ngClass]="{ 'is-invalid': submitted && f?.ssn.errors }" >                       
                        <div *ngIf="submitted && f?.ssn.errors" class="invalid-feedback">
                          <div *ngIf="f?.ssn.errors.required">Social Security Number is required</div>
                        </div></div>                          
                          <div class="col-md-6">
                            <label for="phoneNumber"  class="dangerAstrick">Phone Number</label>
                          <input type="text" formControlName="phoneNumber" name="phoneNumber" id="phoneNumber" class="form-control" placeholder="Phone Number"  [ngClass]="{ 'is-invalid': submitted && f?.phoneNumber.errors }" >                       
                          <div *ngIf="submitted && f?.phoneNumber.errors" class="invalid-feedback">
                            <div *ngIf="f?.phoneNumber.errors.required">Phone Number is required</div>
                            <div *ngIf="f.phoneNumber.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
                          </div>
                          </div>
  
                      </div>
                  
                  <div  class="form-group row">
                    <div class="col-md-6">
                      <label for="password"  class="dangerAstrick">Password</label>
                      <div class="input-group">
                          <input [type]="fieldTextType1 ? 'text' : 'password'" name="password" formControlName="password" id="password" class="form-control iconAdd" placeholder="***********"  [ngClass]="{ 'is-invalid': submitted && f?.password.errors }" >
                          <div class="input-group-append">
                            <span class="input-group-text iconBorder">
                              <i
                                class="fa"
                                [ngClass]="{
                                  'fa-eye-slash': !fieldTextType1,
                                  'fa-eye': fieldTextType1
                                }"
                                (click)="toggleFieldTextType(1)"
                              ></i>
                            </span>
                          </div>
                          <div *ngIf="submitted && f?.password.errors" class="invalid-feedback">
                            <div *ngIf="f?.password.errors.required">Password is required</div>
                            <div *ngIf="f?.password.errors.minlength">Minimum of 6 characters required</div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                      <label for="confirmPassword"  class="dangerAstrick">Confirm Password</label>
                        <div class="input-group">
                            <input [type]="fieldTextType2 ? 'text' : 'password'" name="confirmPassword" formControlName="confirmPassword" id="confirmPassword" class="form-control iconAdd" placeholder="***********"  [ngClass]="{ 'is-invalid': submitted && f?.confirmPassword.errors }" >
                            <div class="input-group-append">
                              <span class="input-group-text iconBorder">
                                <i
                                  class="fa"
                                  [ngClass]="{
                                    'fa-eye-slash': !fieldTextType2,
                                    'fa-eye': fieldTextType2
                                  }"
                                  (click)="toggleFieldTextType(2)"
                                ></i>
                              </span>
                            </div>
                            <div *ngIf="submitted && f?.confirmPassword.errors" class="invalid-feedback">
                              <div *ngIf="f?.confirmPassword.errors.required">Confirm Password is required</div>
                              <div *ngIf="f?.confirmPassword.errors.minlength">Minimum of 6 characters required</div>
                          </div>
                          </div>
                  <div *ngIf="submitted && f?.errors" class="invalid-feedback">
                    <div *ngIf="f?.username.errors.passwordNotMatch">Confirm password mismatched</div>
                  </div>
                </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label for="email"  class="dangerAstrick">Email</label>
                  <input type="email" formControlName="email" name="email" id="email" class="form-control" placeholder="Email address"  [ngClass]="{ 'is-invalid': submitted && f?.email.errors }" >
                    <div *ngIf="submitted && f?.email.errors" class="invalid-feedback">
                    <div *ngIf="f?.email.errors.required">Email is required</div>
                    <div *ngIf="f?.email.errors.email">Email must be a valid email address</div>
                  </div>
                  </div>             
                </div>
                  <input name="Signup" id="Signup" class="btn btn-block signup-btn mt-4 mb-4" type="submit" value="Signup">
                </form>
                <p class="login-card-footer-text text-center">Go to <a  [routerLink]="['/Auth/Login']"  class="text-reset">Login page?</a></p>
                <!-- <div class="text-center">
                <a [routerLink]="['/Auth/ForgotPassword']" class="forgot-password-link">Forgot password?</a>
              </div>
              <p *ngIf="!toAdminLogin" class="login-card-footer-text">Don't have an account? <a  [routerLink]="['/Auth/Register']"  class="text-reset">Register here</a></p> -->
                <!-- <nav class="login-card-footer-nav">
                  <a href="#!">Terms of use.</a>
                  <a href="#!">Privacy policy</a>
                </nav> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
